// mutations do site --------
export const FETCH_PREVIEW_URL_START = "fetchPreviewUrlStart";
export const FETCH_PREVIEW_URL_END = "fetchPreviewUrlEnd";
export const SEND_CONTACT_EMAIL_START = "sendContactEmailStart";
export const SEND_CONTACT_EMAIL_END = "sendContactEmailEnd";

// mutations da aplicação --------
export const SET_TOOLBAR_TITLE = "setToolbarTitle";
export const SET_SOLICITACOES_SHEET = "setSolicitacoesSheet";
export const SET_OVERLAY = "setOverlay";
export const SHOW_MSG_ALERT = "showMsgAlert";
export const SHOW_MSG_CONFIRM = "showMsgConfirm";
export const SHOW_MSG_NOTIFICATION = "showMsgNotification";
export const DESTROY_ALL_MSG = "destroyAllMsg";

// --- mutations de authentication e authorization (logado)
export const CREATE_KEYCLOAK = "createKeycloak";
export const CREATE_TOKEN = "createToken";
export const SET_SELECTED_GROUP = "setSelectedGroup";

// --- mutations padrão para entidades
export const FETCH_ALL_START = "fetchAllStart";
export const SET_ALL = "setAll";
export const FETCH_ALL_END = "fetchAllEnd";

export const FETCH_START = "fetchStart";
export const SAVE_START = "saveStart";
export const SET = "set";
export const FETCH_END = "fetchEnd";
export const SAVE_END = "saveEnd";

export const DELETE_START = "deleteStart";
export const UNSET = "unset";
export const DELETE_END = "deleteEnd";

export const RESET = "reset";

// --- mutations específicas
export const SET_DISCIPLINA = "setDisciplina";
export const UNSET_DISCIPLINA = "unsetDisciplina";
export const UNSET_ALL_DISCIPLINAS = "unsetAllDisciplinas";
export const UNSET_OBSERVACOES = "unsetObservacoes";
export const SEND_SOLICITACAO_EMAIL_START = "sendSolicitacaoEmailStart";
export const SEND_SOLICITACAO_EMAIL_END = "sendSolicitacaoEmailEnd";

export const SEND_RENT_START = "sendRentStart";
export const SEND_RENT_END = "sendRentEnd";

// --- mutations de dashboard
export const FETCH_DASHBOARD_DISCIPLINA_START = "fetchDashboardDisciplinaStart";
export const FETCH_DASHBOARD_DISCIPLINA_END = "fetchDashboardDisciplinaEnd";
export const SET_DASHBOARD_DISCIPLINA = "setDashboardDisciplina";

export const FETCH_DASHBOARD_ALUNO_ACCESS_START = "fetchDashboardAlunoAccessStart";
export const FETCH_DASHBOARD_ALUNO_ACCESS_END = "fetchDashboardAlunoAccessEnd";
export const SET_DASHBOARD_ALUNO_ACCESS = "setDashboardAlunoAccess";

export const FETCH_DASHBOARD_CATALOGO_START = "fetchDashboardCatalogoStart";
export const FETCH_DASHBOARD_CATALOGO_END = "fetchDashboardCatalogoEnd";

export const FETCH_DASHBOARD_CURSO_START = "fetchDashboardCursoStart";
export const FETCH_DASHBOARD_CURSO_END = "fetchDashboardCursoEnd";

export const FETCH_DASHBOARD_EDUCASPACE_START = "fetchDashboardEducaspaceStart";
export const FETCH_DASHBOARD_EDUCASPACE_END = "fetchDashboardEducaspaceEnd";

// --- mutations de dentro dos cards do dashboard
export const SET_ALL_MYDISCIPLINAS = "setAllMyDisciplinas";
export const SET_ALL_MYPAGAMENTOS = "setAllMyPagamentos";

// -- mutations especificas para interfacear GaelApi com EadstockApi
export const SET_UNIDADES = "setUnidades";
export const SET_UNIDADES_FROM_GAEL = "setUnidadesFromGael";
export const SET_DASHBOARD_CATALOGO = "setDashboardCatalogo";
export const SET_DASHBOARD_EDUCASPACE = "setDashboardEducaspace";
export const SET_DASHBOARD_CURSO = "setDashboardCurso";

export const FETCH_DASHBOARD_NOVIDADE_START = "fetchDashboardNovidadeStart";
export const FETCH_DASHBOARD_NOVIDADE_END = "fetchDashboardNovidadeEnd";
export const SET_DASHBOARD_NOVIDADE = "setDashboardNovidade";

export const FETCH_DASHBOARD_RENTS_TIMELINE_START = "fetchDashboardRentsTimelineStart";
export const FETCH_DASHBOARD_RENTS_TIMELINE_END = "fetchDashboardRentsTimelineEnd";
export const SET_DASHBOARD_RENTS_TIMELINE = "setDashboardRentsTimeline";

export const FETCH_DASHBOARD_PERCENTAGE_START = "fetchDashboardPercentageStart";
export const FETCH_DASHBOARD_PERCENTAGE_END = "fetchDashboardPercentageEnd";
export const SET_DASHBOARD_PERCENTAGE = "setDashboardPercentage";

export const FETCH_DASHBOARD_BLOG_START = "fetchDashboardBlogStart";
export const FETCH_DASHBOARD_BLOG_END = "fetchDashboardBlogEnd";
export const SET_DASHBOARD_BLOG = "setDashboardBlog";

export const FETCH_LINE_CHART_START = "fetchLineChartStart";
export const FETCH_LINE_CHART_END = "fetchLineChartEnd";
export const SET_ORIGENS = "setOrigens";
export const SET_LINE_CHART = "setLineChart";

// mutations do pusher
export const SET_CHANNEL = "setChannel";
export const SET_NOTIFICATION = "setNotification";
export const UNSET_ALL_NOTIFICATION = "unsetAllNotification";

// mutations dos relatorios
export const SET_ALL_RELATORIO_PAGAMENTOS_POR_USO = "setAllRelatorioPagamentosPorUso";

export const FETCH_RELATORIO_START = "fetchRelatorioStart";

export const FETCH_RELATORIO_END = "fetchRelatorioEnd";

export const SET_ALL_ORGANIZATION_PARAMS = "setAllOrganizationParams";

export const SET_ALL_ORGANIZATIONS_LITE = "setAllOrganizationsLite";

export const SET_ORGPARAM = "setOrgParam";

export const SET_FORNECEDOR_PLANOS = "setFornecedorPlanos";

//mutations de customer
export const SAVE_CUSTOMER_START = "saveCustomerStart";
export const SAVE_CUSTOMER_END = "saveCustomerEnd";

// mutations documentos
export const SET_DOCUMENT = "setDocument";
export const SIGN_URL_START = "signUrlStart";
export const SIGN_URL_END = "signUrlEnd";

// mutations organization
export const SET_ORGANIZATION = "setOrganization";
export const SET_ORGANIZATIONS_FORNECEDORAS = "setOrganizationsFornecedoras";
export const SET_ORGANIZATIONS_CLIENTES = "setOrganizationsClientes";

export const UNSET_ALL = "unsetAll";


// mutation auto-complete client-side
export const AUTO_COMPLETE_CLIENT_SIDE_SET_ALL = "autoCompleteClientSideSetAll";
export const AUTO_COMPLETE_CLIENT_SIDE_FETCH_START = "autoCompleteClientSideFetchStart";
export const AUTO_COMPLETE_CLIENT_SIDE_FETCH_END = "autoCompleteClientSideFetchEnd";

// mutation auto-complete server-side
export const AUTO_COMPLETE_FETCH_ALL_START = "autoCompleteFetchAllStart";
export const AUTO_COMPLETE_SET_ALL = "autoCompleteSetAll";
export const AUTO_COMPLETE_FETCH_ALL_END = "autoCompleteFetchAllEnd";
export const AUTO_COMPLETE_UNSET_ALL = "autoCompleteUnsetAll";

export const FETCH_ALL_PDF_EMENTA_START = "fetchAllPdfEmentaStart";
export const FETCH_ALL_PDF_EMENTA_END = "fetchAllPdfEmentaEnd";

//mutation editar parametros
export const SET_PARAMETROS = "setParametros";

//mutation curso categorias
export const SET_ALL_CURSO_CATEGORIAS = "setAllCursoCategorias";

//mutation relatorios:
export const SET_ALL_ROYALTIES_RELATORIO = "setAllRoyaltiesRelatorio";

export const FETCH_ALL_PDF_START = "fetchAllPdfStart";
export const FETCH_ALL_PDF_END = "fetchAllPdfEnd";

export const FETCH_ALL_CSV_START = "fetchAllCsvStart";
export const FETCH_ALL_CSV_END = "fetchAllCsvEnd";


export const SET_DEFAULT_USER = "setDefaultUser";

// mutations area TI
export const FETCH_DISCIPLINAS_RETURN_START = "fetchDisciplinasReturnStart";

export const FETCH_DISCIPLINAS_RETURN_END = "fetchDisciplinasReturnEnd";

export const FETCH_COBRANCAS_START = "fetchCobrancasStart";

export const FETCH_COBRANCAS_END = "fetchCobrancasEnd";

export const FETCH_FORNECEDORES_UNIDADES_START = "fetchFornecedoresUnidadesStart";

export const FETCH_FORNECEDORES_UNIDADES_END = "fetchFornecedoresUnidadesEnd";

export const SET_FORNECEDORES_UNIDADES_RETURN = "fetchFornecedoresUnidadesReturn";

export const SET_COBRANCAS_RETURN = "setCobrancasReturn";

export const SET_SYNC_DISCIPLINAS_RETURN = "setSyncDisciplinasReturn";

export const SET_UNIDADES_FORNECEDORES_ZERADO = "setUnidadesFornecedoresZerado";

export const SET_ALL_GROUPS_KEYCLOAK = "setAllGroupsKeycloak";
